import { formatDataTest } from '@/common/dataTest/DataTest';
import { useInDialog } from '@/common/dialog/DialogScopeContext';
import { TextField } from '@mui/material';
import { useFormFieldDef } from '../hooks/useFormFieldDef';

export const TextFormField = ({ fieldDef, type }) => {
  const { value, setValue, onBlur, error, helperText, label, disabled } = useFormFieldDef(fieldDef);
  const inDialog = useInDialog();

  return (
    <TextField
      type={type}
      slotProps={{
        input: { 'data-test-id': formatDataTest(inDialog ? 'dialog' : 'main', 'form-field', fieldDef.displayName) }
      }}
      value={value}
      onChange={(event) => setValue(event.target.value)}
      onBlur={onBlur}
      error={!disabled && error}
      helperText={helperText}
      label={label}
      disabled={disabled}
    />
  );
};
